<template>
  <div>
    <headIndex></headIndex>
    <indexDynamic></indexDynamic>
    <indexResearch></indexResearch>
<!--     <indexPlatform></indexPlatform> -->
    <indexAlumnus></indexAlumnus>
    <indexGraduate></indexGraduate>
    <footerIndex></footerIndex>
  </div>
</template>

<script>
import indexDynamic from '@/components/indexDynamic'
import indexResearch from '@/components/indexResearch'
import indexAlumnus from '@/components/indexAlumnus'
import indexGraduate from '@/components/indexGraduate'
export default {
  name: 'indexLab',
  components: {
    indexDynamic,
    indexResearch,
    indexAlumnus,
    indexGraduate
  }
}
</script>

<style lang="less">

</style>
